
const initOfficialStampCheckBox = () => {

  const checkbox = document.querySelector("#stamped_image_checkbox")

  console.log({checkbox})

  if (checkbox) {
    checkbox.addEventListener('change', (e) => {
      if (e.target.checked) {
        document.querySelector("#stamped_image_container").style.display = 'block'
      } else {
        document.querySelector("#stamped_image_container").style.display = 'none'
      }
    });
  }
}

const initYesNoCheckBox = () => {
  console.log("checkbox starting")

  initOfficialStampCheckBox()

  let yesNoContainer = document.querySelectorAll('.yes-no-checkbox-container');

  console.log({yesNoContainer})

  // Iterate over each selected div
  yesNoContainer.forEach((div) => {

    


    // Find the checkbox input element
    let checkbox = div.querySelector('input[type="checkbox"]');

    // Create a new label element with the text 'Yes'
    let labelYes = document.createElement('span');
    labelYes.classList.add('yes-no-checkbox-label');
    labelYes.textContent = 'Yes';

    // Append the label to the checkbox input element
    checkbox.parentNode.insertBefore(labelYes, checkbox.nextSibling);

    // Create a new checkbox input element for 'No'
    let checkboxNo = document.createElement('input');
    checkboxNo.type = 'checkbox';
    checkboxNo.classList.add('table-input-checkbox');
    checkboxNo.checked = !checkbox.checked;
    
    // Create a new label element with the text 'No'
    let labelNo = document.createElement('span');
    labelNo.classList.add('yes-no-checkbox-label');
    labelNo.textContent = 'No';

    // Append the 'No' checkbox and label to the parent node
    checkbox.parentNode.appendChild(checkboxNo);
    checkbox.parentNode.appendChild(labelNo);

    checkbox.addEventListener('change', (e) => {
      checkboxNo.checked = !checkbox.checked;
    });

    checkboxNo.addEventListener('change', (e) => {
      checkbox.checked = !checkboxNo.checked;
    });
  });
}

export default initYesNoCheckBox